import axios from "axios";
import Router from "@/router";

const ruoffLogging = axios.create({
    baseURL: process.env.VUE_APP_LOGGING_API_URL,
    headers: {
        APIKey: process.env.VUE_APP_LOGGING_API_KEY
    },
});

export default {
    methods: {
        addLogging: function (axiosInstance) {
            axiosInstance.interceptors.response.use(
                response => response,
                error => {
                    if (!error.response.ok) {
                        const userID = localStorage.getItem("userID");
                        let body = {
                            "ApplicationID": 83,
                            "ResultID": 4,
                            "Message": error.response.data,
                            "UserID": userID,
                            "ServerName": location.host,
                            "CreatedOn": new Date().toISOString(),
                        };
                        ruoffLogging.post("LogEvent", body).catch(error => {console.error(error)});
                    }
                    if (error.response.status === 401) {
                        Router.push("/login");
                    }
                    return Promise.reject(error);
                });
        },
        addToken: function (axiosInstance) {
            axiosInstance.interceptors.request.use(
                config => {
                    const token = localStorage.getItem("wlv4");
                    if (token) {
                        config.headers.Authorization = token;
                    }
                    return config;
                },
                error => {
                    return Promise.reject(error);
                }
            );
        }
    },
}
